


































































import { Component, Prop, Model } from 'vue-property-decorator';

import { formatString } from '@/utils/moneyTreatments';

import { HTMLInputEvent } from '@/components/TextArea/TextAreaModel';

import InputBase from './InputBase.vue';
import InputWrapper from './InputWrapper.vue';

@Component<TextField>({
  components: {
    InputWrapper
  }
})
export default class TextField extends InputBase {
  @Model('input', { default: '' }) value!: any;

  @Prop({ default: 'text' }) type?: string;
  @Prop(String) name!: string;
  @Prop(String) mask?: string;
  @Prop(String) restrictCharsRule?: string;
  @Prop({ default: '' }) placeholder?: string;
  @Prop({ default: false }) autofocus?: boolean;
  @Prop({ default: 'off' }) autocomplete?: string;
  @Prop({ default: '' }) maxlength?: string;
  @Prop() inputmode?: string;
  @Prop() accept?: string;
  @Prop() tippy?: string;
  @Prop() rightText?: string;
  @Prop({ default: false }) rightLabelClickable?: boolean;

  @Prop({ default: false }) multiline?: boolean;
  @Prop({ default: false }) optional?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: true }) showHelpIcon?: boolean;
  @Prop() tabIndex?: string;
  @Prop({ default: true }) showCounter?: boolean;
  @Prop() prependValue?: string;

  showPassword = false;

  get helpErrId() {
    return `err-${this.name}`;
  }

  handleClickShowPassword() {
    this.showPassword = !this.showPassword;
  }

  handleMouseDownPassword(event: MouseEvent) {
    event.preventDefault();
  }

  updateValue(value: string, event: HTMLInputEvent) {
    if (this.maxlength) {
      const newValue = value.substr(0, +this.maxlength);
      event.target.value = newValue;
    }

    if (this.mask) {
      switch (this.mask) {
        case 'phone':
          /*
            mask pattern: +1 XXX XXX-XXXX
          */

          var matchMask = value
            .replace(/\D/g, '')
            .match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);

          /*
           matchMask[0] - raw value
           matchMask[1] - country code (fixed as +1)
           matchMask[2] - 3-digit area code
           matchMask[3] - 3-digit central office number
           matchMask[4] - 4-digit subscriber number
          */

          if (matchMask) {
            let masked = '+1 ';

            // insert the first value of the input
            if (!this.value) {
              matchMask[2] = matchMask[1];
            }

            if (!matchMask[3]) {
              masked += matchMask[2];
            } else {
              masked +=
                matchMask[2] +
                ' ' +
                matchMask[3] +
                (matchMask[4] ? '-' + matchMask[4] : '');
            }

            event.target.value = masked;
            this.$emit('input', masked);
          }
          return;

        case 'percentage':
          /**
           * Mask Pattern: XX
           */

          var matchMaskPercentage = value
            .replace(/\D/g, '')
            .match(/(\d{0,2})(\d{0,1})/);
          if (matchMaskPercentage) {
            let masked = matchMaskPercentage[1];

            if (
              matchMaskPercentage[1] === '10' &&
              matchMaskPercentage[2] === '0'
            ) {
              masked += matchMaskPercentage[2];
            }

            event.target.value = masked;
            this.$emit('input', masked);
          }
          return;

        case 'currency':
          /**
           * Mask Pattern: XXX.XXX,XX
           */

          var matchMaskCurrency = value.replace(/[^0-9,.]/g, '');
          var masked = formatString(matchMaskCurrency);

          event.target.value = masked;
          this.$emit('input', masked);
          return;

        case 'currency-negative':
          /**
           * Mask Pattern: XXX.XXX,XX
           */

          var negativeOccurences = (value.match(/-/g) || []).length;
          var isNegative = negativeOccurences === 1;

          matchMaskCurrency = value.replace(/[^0-9,.-]/g, '');
          masked = formatString(matchMaskCurrency);

          masked = isNegative ? '-' + masked : masked;
          event.target.value = masked;
          this.$emit('input', masked);
          return;

        case 'url':
          /**
           * Mask Pattern: xxxx.xxx
           */

          var matchMaskUrl = value.replace(/^https?:\/{0,2}/, '');

          event.target.value = matchMaskUrl;
          this.$emit('input', matchMaskUrl);
          return;
      }
    }

    if (this.restrictCharsRule) {
      let firstChar = '';
      let newValue = event.target.value;
      switch (this.restrictCharsRule) {
        case 'coinName':
          newValue = newValue.replace(/--+/g, '-');
          if (newValue.charAt(0) === '-' || newValue.charAt(0) === ' ') {
            firstChar = newValue.charAt(0);
          }

          newValue = newValue.replace(/[^a-zA-Z0-9- ]+/g, '');
          if (firstChar !== '') {
            newValue = newValue
              .substring(1, newValue.length)
              .replace(/ +/g, '-');
            newValue = firstChar + newValue;
          } else {
            newValue = newValue.replace(/ +/g, '-');
          }

          newValue = newValue.replace(/--+/g, '-');
          newValue = newValue.toLocaleLowerCase();
          event.target.value = newValue;
          break;
      }
    }
    this.$emit('input', this.type === 'file' ? event : event.target.value);
  }

  triggerInputEvent() {
    const textarea: HTMLInputElement | null = document.querySelector(
      `[name="${this.name}"]`
    );
    if (textarea) {
      textarea.value = this.value;
      const event = new Event('input', { bubbles: true });
      textarea.dispatchEvent(event);
    }
  }

  mounted() {
    if (this.multiline && this.value) this.triggerInputEvent();
  }
}
